<div class="modern-profile-page">
  <main class="profile-content">
    @if (!(isProfileContentReady && isRequireInfoReady)) {
    <app-profile-loading></app-profile-loading>
    }

    <!-- Shipment Notification Card -->
    @if (isProfileContentReady && isRequireInfoReady && latestShipment) {
    <section class="notification-card">
      <div class="notification-content">
        <div class="notification-icon">
          <mat-icon>local_shipping</mat-icon>
        </div>
        <div class="notification-text">
          <h3>New Shipment Assigned</h3>
          <p>Shipment <strong>{{ latestShipment?.shipmentID }}</strong> has been assigned to you!</p>
        </div>
      </div>
      <div class="notification-actions">
        <button mat-flat-button color="primary" (click)="navigateToShipmentDetail(latestShipment)">
          VIEW DETAILS
        </button>
        <button mat-button (click)="closeShipmentNotification()">
          DISMISS
        </button>
      </div>
    </section>
    }

    <!-- Profile Overview Section -->
    @if (isProfileContentReady && isRequireInfoReady) {
    <section class="profile-overview">
      <!-- Driver Information Card -->
      <div class="profile-info-card">
        <div class="profile-identity-header">
          <div class="profile-avatar-section">
            <div class="profile-avatar-container">
              <img [src]="profilePicturePath" class="profile-avatar" alt="Profile Picture"
                (error)="onImageError($event)" (load)="onImageLoad($event)" />
            </div>
          </div>
          <div class="profile-main-info">
            <h2 class="driver-name">{{ driverName }}</h2>
            <p class="driver-email">{{ driverEmail }}</p>
            <span class="driver-id-inline">{{ driverId | uppercase }}</span>
          </div>
          <button mat-icon-button class="profile-edit-icon" (click)="onNavigateToPersonalInformation()"
            data-testid="edit-profile-btn" data-test="edit-profile" aria-label="Edit Profile">
            <mat-icon svgIcon="edit-black"></mat-icon>
          </button>
        </div>
      </div>
    </section>
    }
    <!-- Incomplete Profile Warning -->
    @if (isProfileContentReady && isRequireInfoReady && showPercentage < 80) {
    <div class="profile-incomplete-banner">
      <mat-icon class="banner-icon">warning</mat-icon>
      <div class="banner-text">
        <span class="banner-title">Your profile is incomplete</span>
        <span class="banner-desc">Please complete all required steps to start accepting jobs.</span>
      </div>
    </div>
    }

    <!-- Required Information Section -->
    <section class="info-section required-section">
      <div class="section-header" (click)="requiredExpanded = !requiredExpanded">
        <h2 class="section-title">
          Required Information
        </h2>
        <div class="section-meta">
          <app-modern-circular-progress [value]="showPercentage" [size]="48"
            [color]="showPercentage > 99 ? '#10b981' : '#3b82f6'" [backgroundColor]="'#d1d5db'" [strokeWidth]="3.5">
          </app-modern-circular-progress>
          <mat-icon class="expand-icon" [class.expanded]="requiredExpanded">expand_more</mat-icon>
        </div>
      </div>

      <div class="section-content" [class.expanded]="requiredExpanded !== false">
        @if (!(isProfileContentReady && isRequireInfoReady)) {
        <div class="section-loading">
          <mat-spinner diameter="40"></mat-spinner>
          <p class="loading-text">Loading required information...</p>
        </div>
        }

        @if (isProfileContentReady && isRequireInfoReady) {
        <div class="info-grid">
          @for (info of requiredInformation; track info; let i = $index) {
          <article class="info-card" [class.complete]="info.isComplete" (click)="onRequiredStepClick(info, i)"
            data-test="document-category" [attr.data-testid]="'docCatagory-' + info?.displayName?.toLowerCase()">
            <div class="step-number-badge" [class.step-done]="info.isComplete">
              <span>{{ i + 1 }}</span>
            </div>
            <div class="info-content">
              <div class="info-header">
                <h3 class="info-title">{{ info.displayName }}</h3>
                <div class="info-status">
                  @if (info.isComplete) {
                  <mat-icon class="complete-icon"
                    [attr.data-testid]="info?.displayName?.toLowerCase() + '-status-complete'">
                    check_circle
                  </mat-icon>
                  }
                  @if (!info.isComplete) {
                  <mat-icon class="incomplete-icon"
                    [attr.data-testid]="info?.displayName?.toLowerCase() + '-status-incomplete'">
                    radio_button_unchecked
                  </mat-icon>
                  }
                </div>
              </div>
            </div>
          </article>
          }
        </div>
        }
      </div>
    </section>

    <!-- Additional Information Section -->
    <section class="info-section additional-section">
      <div class="section-header" (click)="additionalExpanded = !additionalExpanded" data-testid="additionalInfo-header">
        <h2 class="section-title">
          Additional Information
        </h2>
        <div class="section-meta">
          <span class="completion-badge" [class.complete]="additionalRequired === totalAdditionalInfoCount">
            {{ additionalRequired }}/{{ totalAdditionalInfoCount }} Completed
          </span>
          <mat-icon class="expand-icon" [class.expanded]="additionalExpanded">expand_more</mat-icon>
        </div>
      </div>

      <div class="section-content" [class.expanded]="additionalExpanded !== false">
        @if (!(isProfileContentReady && isRequireInfoReady)) {
        <div class="section-loading">
          <mat-spinner diameter="40"></mat-spinner>
          <p class="loading-text">Loading additional information...</p>
        </div>
        }

        @if (isProfileContentReady && isRequireInfoReady) {
        <div class="info-grid">
          @for (info of additionalInformation; track info) {
          <article class="info-card" [class.complete]="info.isComplete" (click)="info.clickHandler()"
            [attr.data-testid]="'section-' + info?.displayName?.toLowerCase()">
            <div class="info-content">
              <div class="info-header">
                <h3 class="info-title">{{ info.displayName }}</h3>
                <div class="info-status">
                  @if (info.isComplete) {
                  <mat-icon class="complete-icon"
                    [attr.data-testid]="info?.displayName?.toLowerCase() + '-status-complete'">
                    check_circle
                  </mat-icon>
                  }
                  @if (!info.isComplete) {
                  <mat-icon class="incomplete-icon"
                    [attr.data-testid]="info?.displayName?.toLowerCase() + '-status-incomplete'">
                    radio_button_unchecked
                  </mat-icon>
                  }
                </div>
              </div>
            </div>
          </article>
          }
        </div>
        }
      </div>
    </section>
  </main>
</div>